import { FC, useMemo, useState } from 'react'

interface Props {
  text: string
  driection?: 'top' | 'bottom' | 'left' | 'right'
  offset?: number
  onShow?: () => void
  onHide?: () => void
}

const HoverTip: FC<Props> = ({ children, text, driection, offset, onShow, onHide }) => {
  const [show, setShow] = useState(false)

  const _driection = driection ?? 'left'
  const position = useMemo(() => {
    const pre = ['top', 'left'].includes(_driection) ? -1 : 1
    if (['top', 'bottom'].includes(_driection)) {
      return {
        left: '50%',
        transform: `translate(-50%, calc(${pre * 100}% + ${pre * (offset ?? 0)}px))`,
        [_driection]: '0px'
      }
    } else {
      console.log('---', `translate(calc(${pre * 100}% + ${pre * (offset ?? 0)}px), -50%)`)
      return {
        top: '50%',
        transform: `translate(calc(${pre * 100}% + ${pre * (offset ?? 0)}px), -50%)`,
        [_driection]: '0px'
      }
    }
  }, [_driection, offset])

  const mouseOverHandle = () => {
    setShow(true)
    onShow?.()
    console.log('- mouse over')
  }

  const mouseOutHandle = () => {
    setShow(false)
    onHide?.()
  }

  return (
    <div
      className={`relative w-full h-full hover-tip-wrap `}
      onMouseOverCapture={mouseOverHandle}
      onMouseOutCapture={mouseOutHandle}>
      {children}
      <div
        style={position}
        className={`pointer-events-none absolute whitespace-nowrap py-[10px] px-[12px] text-[12px] leading-[12px] bg-white/[0.9] rounded-[6px] hover-tip-text ${!show && 'hidden'}`}>
        { text }
      </div>
    </div>
  )
}

export default HoverTip
